import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { APPHOST } from '../../app.component';

export interface WelcomeScreenMedia {
  id?: string;
  index?: number;
  characterImage?: string;
  backgroundImage?: string;
}

type WelcomeScreenMediaApiResponse =
  | WelcomeScreenMedia[]
  | {
      content?: WelcomeScreenMedia[];
      data?: WelcomeScreenMedia[];
      items?: WelcomeScreenMedia[];
    };

@Injectable({ providedIn: 'root' })
export class WelcomeScreenMediaService {
  private readonly apiUrl = `${APPHOST}/api/welcome-heroes/web`;
 
  constructor(private readonly http: HttpClient) {}

  getWelcomeScreenMedia(page: number = 0, size: number = 100): Observable<WelcomeScreenMedia[]> {
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('size', size.toString());

    return this.http.get<WelcomeScreenMediaApiResponse>(this.apiUrl, { params }).pipe(
      map((response) => this.normalizeResponse(response))
    );
  }

  private normalizeResponse(response: WelcomeScreenMediaApiResponse): WelcomeScreenMedia[] {
    if (Array.isArray(response)) {
      return response;
    }

    return response.content ?? response.data ?? response.items ?? [];
  }
}
